// extracted by mini-css-extract-plugin
export default {"renderedInput":"suggested-item-picker-module__renderedInput--wn4pP"};